export enum LocationModule {
  PROCUREMENT = 'procurement',
  MEASURES = 'measures',
  ISO50001 = 'iso50001',
  MESSSTELLEN = 'messstellen',
  AI_INVOICE_CHECKING = 'ai-invoice-checking',
  INVOICE_CHECKING = 'invoice-checking',
  PROCUREMENT_FREEMIUM = 'procurement-freemium',
  REPORTS = 'reports',
  ANALYSES = 'analyses',
  DATA_MANAGEMENT = 'data-management',
  FLEX = 'flex',
  ENERGY_COST = 'energy-cost',
  CUSTOM_SECTION = 'custom-section',
  INSIGHT_INBOX = 'insight-inbox',
}

export interface FilterableByModule {
  module?: LocationModule
  hideIfEnabled?: LocationModule
}
